export function getHttpErrorMessage(error: any, fallbackMessage: string): string {
  const status = Number(error?.status || error?.statusCode || 0);
  const hasStatus = error?.status !== undefined || error?.statusCode !== undefined;
  const rawMessage = extractMessage(error?.error?.message) || extractMessage(error?.error?.error) || extractMessage(error?.error?.detail);
  const normalizedMessage = rawMessage.toLowerCase();

  if (hasStatus && status === 0) {
    return 'Não foi possível conectar ao serviço. Verifique sua conexão e tente novamente.';
  }

  if (normalizedMessage.includes('external_id') && normalizedMessage.includes('unique')) {
    return 'Já existe um recebedor cadastrado para esta conta.';
  }

  if (normalizedMessage.includes('recipient could not be created') || normalizedMessage.includes('invalid_parameter')) {
    return 'Não foi possível validar o cadastro de pagamentos. Confira os dados e tente novamente.';
  }

  if (normalizedMessage.includes('secretarias nao podem configurar pagamentos')) {
    return 'A secretária não pode alterar as configurações de pagamento da organização.';
  }

  if (normalizedMessage.includes('insufficient funds') || normalizedMessage.includes('insufficient_funds')) {
    return 'O pagamento foi recusado por falta de limite ou saldo disponível.';
  }

  if (normalizedMessage.includes('card') && (normalizedMessage.includes('declined') || normalizedMessage.includes('refused'))) {
    return 'O cartão foi recusado. Confira os dados ou tente outro cartão.';
  }

  const candidates = [error?.error?.message, error?.error?.error, error?.error?.detail, error?.message];

  for (const candidate of candidates) {
    const message = extractMessage(candidate);

    if (message) {
      return message;
    }
  }

  return fallbackMessage;
}

function extractMessage(value: any): string {
  if (typeof value === 'string' && value.trim()) {
    return value.trim();
  }

  if (Array.isArray(value)) {
    return value.map(extractMessage).filter(Boolean).join(' ');
  }

  if (value && typeof value === 'object') {
    if (typeof value.message === 'string' && value.message.trim()) {
      return value.message.trim();
    }

    if (Array.isArray(value.errors)) {
      return value.errors.map(extractMessage).filter(Boolean).join(' ');
    }
  }

  return '';
}
